<p-button label="{{label}}" icon="pi pi-check" styleClass="p-button-sm"></p-button>